import React, { useState, useEffect, useContext } from "react";
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Checkbox, 
  FormControlLabel,
  Card,
  CardContent,
  Grid,
  Stack,
  Divider,
  useTheme,
  alpha,
  Chip,
  InputAdornment
} from "@mui/material";
import { 
  CreditCard, 
  Lock, 
  CheckCircle,
  Payment as PaymentIcon,
  Security as SecurityIcon
} from "@mui/icons-material";
import { IMaskInput } from "react-imask";
import CountrySelect from "../../Components/CountrySelect";
import { LoadingButton } from "@mui/lab";
import { createAxiosInstance } from "../../api";
import { useNavigate } from "react-router-dom";
import { showErrorMessage } from "../../utils";
import { CreateCourseContext } from "../AddCourse/AddCourseContext/AddContextContext";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const TextMaskCustom0 = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="#### #### #### ####"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { value } })}
      overwrite
    />
  );
});

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="##/##"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { value } })}
      overwrite
    />
  );
});

const TextMaskCustom1 = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="###"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { value } })}
      overwrite
    />
  );
});

const CourseBilling = ({ advancePrice, duration, courseName, onPaymentSuccess, onPaymentFailure, isRenewal = false }) => {
  const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  const stripePromise = loadStripe(stripePublicKey); // Replace with your actual Stripe publishable key
  const theme = useTheme();

  // Stripe card element styles
  const cardElementStyles = {
    base: {
      fontSize: '16px',
      color: theme.palette.text.primary,
      '::placeholder': {
        color: theme.palette.text.secondary,
      },
    },
    invalid: {
      color: theme.palette.error.main,
    },
  };

  const stripe = useStripe();
  const elements = useElements();

  const {
    setsendReq,
    sendReq,
    coursePrice,
    setCoursePrice,
    setIsPaymentSuccessful,
    isPaymentSuccessful,
  } = useContext(CreateCourseContext);
  const [error, setError] = useState({});
  const [name, setName] = useState("");
  const [card, setCard] = useState("");
  const [expire, setExpire] = useState("");
  const [cvc, setCvc] = useState("");
  const [country, setCountry] = useState("GB");
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(coursePrice);
  const [paymentProcessed, setPaymentProcessed] = useState(false);

  const tokenData = JSON.parse(localStorage.getItem("Token"));
  //const userId = tokenData?.userInfo?._id;
  //const userIdnew = useSelector((state) => state.profile.user.user);

  //console.log("userId", userId);

  let userId;
  try {
    const persistedData = localStorage.getItem("persist:root");
    const userData = JSON.parse(persistedData);
    if (userData.userId && typeof userData.userId === "string") {
      userData.userId = userData.userId.replace(/\\/g, "");
    }
    userId = userData?.userId;
  } catch (error) {
    console.error("Error parsing localStorage data:", error);
    userId = null;
  }

  let userIdnew = userId.replace(/"/g, ""); // Remove extra quotes;

  console.log("userIdnew", userIdnew);

  useEffect(() => {
    if (coursePrice) {
      const numericValue = parseFloat(coursePrice.replace("£", "")) * 100;
      setPrice(Math.round(numericValue));
    }
  }, [coursePrice]);

  useEffect(() => {
    console.log("price", price);
  }, [price]);

  useEffect(() => {
    console.log("SetSendReq", setsendReq);
  }, [setsendReq]);

  const handleError = () => {
    let newError = {};
    const body = {
      card: card.replace(/ /g, ""),
      expire: expire.replace(/\//g, ""),
      cvc,
    };
    card.replace(/ /g, "");
    if (name.trim().length === 0) newError.name = "Please input your name";
    if (body.card.trim().length !== 16)
      newError.card = "Please input valid card number";
    if (body.card.trim().length === 0) newError.card = "Please input your name";
    if (body.expire.trim().length === 0)
      newError.expire = "Please input your name";
    else if (body.expire.trim().length !== 4)
      newError.expire = "Please input valid value";
    else {
      // Get the current date
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // January is represented by 0, so we add 1 to get the actual month number
      const currentYear = currentDate.getFullYear();

      // Convert the expire value into month and year
      const expire_month = parseInt(body.expire.trim().slice(0, 2));
      const expire_year = 2000 + parseInt(body.expire.trim().slice(2));

      // Check if the expiration date is before the current date
      const isExpired =
        expire_year < currentYear ||
        (expire_year === currentYear && expire_month < currentMonth);

      if (expire_month < 1 || expire_month > 12 || isExpired)
        newError.expire = "Please input valid value";
    }
    if (body.cvc.trim().length < 3) newError.cvc = "Please input valid value";
    if (body.cvc.trim().length === 0) newError.cvc = "Please input your name";
    setError(newError);
    if (Object.keys(newError).length > 0) return null;
    return body;
  };

  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      // Prevent duplicate submissions
      if (loading || paymentProcessed) {
        console.log("Payment already in progress or completed.");
        return;
      }

      if (!stripe || !elements) {
        console.error("Stripe or Elements not available.");
        showErrorMessage("Payment processing is not available at this time.");
        return;
      }

      const cardElement = elements.getElement(CardNumberElement);

      if (!cardElement) {
        console.error("Card element is missing.");
        showErrorMessage("Card details are missing. Please enter them.");
        return;
      }

      setLoading(true);

      console.log("Attempting to create Stripe token...");
      const { token, error } = await stripe.createToken(cardElement);

      if (error) {
        console.error("Stripe token creation error:", error.message);
        Swal.fire({
          icon: "error",
          title: "Payment Failed",
          text: error.message,
        });
        return;
      }

      console.log("Stripe token created successfully:", token);
      await charge(token.id);
    } catch (err) {
      console.error("Unexpected error in handleClick:", err);
      showErrorMessage(err.message || "An error occurred during payment.");
    } finally {
      setLoading(false);
      console.log("Loading state set to false.");
    }
  };

  const charge = async (token) => {
    try {
      // Ensure user is logged in
      if (!userIdnew) {
        Swal.fire({
          icon: "error",
          title: "Payment Error",
          text: "User not logged in. Please sign in and try again.",
          confirmButtonColor: "#712d94",
        });
        return;
      }

      // Create Axios instance
      const axiosInstance = createAxiosInstance();
      if (!axiosInstance) {
        throw new Error("Axios instance could not be created.");
      }

      // Send payment request
      const response = await axiosInstance.post("/api/billings/createAdvert/", {
        userId: userIdnew,
        coursePrice: advancePrice,
        token,
        purchaseType: "advert",
        courseName: courseName || "",
      });

      console.log("Backend response received:", response?.data);

      // Handle 3D Secure authentication if required
      if (response.data?.requiresAction && response.data?.clientSecret) {
        if (!stripe) {
          throw new Error("Stripe is not initialized. Please refresh the page.");
        }

        const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(
          response.data.clientSecret
        );

        if (confirmError) {
          throw new Error(confirmError.message || "Authentication failed");
        }

        if (paymentIntent?.status !== "succeeded") {
          throw new Error("Payment authentication was not completed successfully");
        }

        console.log("3D Secure authentication completed successfully for advert purchase");
      }

      if (response?.data?.success || response?.data?.requiresAction) {
        // Mark payment as processed to prevent duplicate submissions
        setPaymentProcessed(true);
        setsendReq(true);
        setIsPaymentSuccessful(true);

        console.log("IsPaymentSuccessful modal", isPaymentSuccessful);
        
        // Call the payment success callback if provided
        if (onPaymentSuccess) {
          await onPaymentSuccess();
        }
      } else {
        throw new Error(
          response?.data?.message || "Payment processing failed."
        );
      }
    } catch (err) {
      console.error(
        "Error in charge function:",
        err.response || err.message || err
      );

      Swal.fire({
        icon: "error",
        title: "Payment Failed",
        text:
          err.response?.data?.message ||
          err.message ||
          "An unexpected error occurred.",
        confirmButtonColor: "#712d94",
      });
      
      // Call payment failure callback if provided
      if (onPaymentFailure) {
        await onPaymentFailure();
      }
    }
  };

  return (
    <Box sx={{ p: 0 }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 1.5, pt: 1 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: theme.palette.primary.main,
            mb: 1.5,
            '&::after': {
              content: '""',
              display: 'block',
              width: '60px',
              height: '4px',
              backgroundColor: theme.palette.primary.main,
              borderRadius: '2px',
              margin: '12px auto 0'
            }
          }}
        >
          Advertisement Payment
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            color: theme.palette.text.secondary,
            maxWidth: '600px',
            mx: 'auto',
            lineHeight: 1.6,
            textAlign: 'center'
          }}
        >
          {isRenewal
            ? `By renewing your advertisement, it will be reviewed by the admin. Once approved, 
               it will be displayed on the website again for parents and students to see. You will be 
               notified by email once the advertisement goes live.`
            : `By paying for your advertisement, it will be created and reviewed by the admin. Once approved, 
               it will be displayed on the website for parents and students to see. You will be 
               notified by email once the advertisement goes live.`
          }
        </Typography>
      </Box>

      <Grid container spacing={1.5}>
        {/* Left Side - Pricing Card */}
        <Grid item xs={12} md={4}>
          <Card 
            sx={{ 
              height: '100%',
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              color: 'white',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <CardContent sx={{ p: 2.5, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              {/* Simplified Price Display */}
              <Box sx={{ mb: 2, textAlign: 'center' }}>
                <Typography variant="h2" sx={{ fontWeight: 700, mb: 1, fontSize: '3rem' }}>
                  {advancePrice}
                </Typography>
                <Typography variant="h6" sx={{ opacity: 0.9, fontSize: '1.2rem' }}>
                  {duration === "12"
                    ? "1 Year"
                    : duration === "1"
                    ? "1 Month"
                    : `${duration} Months`}
                </Typography>
              </Box>
              
              <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', my: 1.5 }} />
              
              {/* Centered Secure Payments Section */}
              <Box sx={{ mt: 'auto', textAlign: 'center' }}>
                <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
                  Secure Payments
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Lock sx={{ fontSize: 16 }} />
                  <Typography variant="caption" sx={{ opacity: 0.8 }}>
                    Powered by Stripe
                  </Typography>
                </Box>
                {/* Payment Method Icons */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5 }}>
                  <Box sx={{ 
                    width: 40, 
                    height: 25, 
                    borderRadius: 1, 
                    bgcolor: 'rgba(255,255,255,0.2)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                    fontWeight: 600
                  }}>
                    VISA
                  </Box>
                  <Box sx={{ 
                    width: 40, 
                    height: 25, 
                    borderRadius: 1, 
                    bgcolor: 'rgba(255,255,255,0.2)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                    fontWeight: 600
                  }}>
                    MC
                  </Box>
                  <Box sx={{ 
                    width: 40, 
                    height: 25, 
                    borderRadius: 1, 
                    bgcolor: 'rgba(255,255,255,0.2)', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontSize: '0.7rem',
                    fontWeight: 600
                  }}>
                    AMEX
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Right Side - Payment Form */}
        <Grid item xs={12} md={8}>
          <Card sx={{ height: '100%' }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                <PaymentIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Payment Details
                </Typography>
              </Box>

              <Stack spacing={1.5}>
                {/* Card Holder Name */}
                <TextField
                  fullWidth
                  size="small"
                  label="Card holder name"
                  placeholder="First and last name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={!!error["name"]}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CreditCard color="action" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                    },
                  }}
                />

                {/* Price Display */}
                <TextField
                  fullWidth
                  size="small"
                  label="Price"
                  value={
                    duration === 1
                      ? `1 month (${advancePrice})`
                      : duration === 12
                      ? `1 year (${advancePrice})`
                      : `${duration} months (${advancePrice})`
                  }
                  disabled
                  sx={{
                    '& .MuiInputBase-input': {
                      color: theme.palette.text.primary,
                      fontWeight: 500,
                    },
                  }}
                />

                {/* Card Details */}
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                    Card details
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CardNumberElement options={{ style: cardElementStyles }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CardExpiryElement options={{ style: cardElementStyles }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <CardCvcElement options={{ style: cardElementStyles }} />
                    </Grid>
                  </Grid>
                </Box>

                {/* Country */}
                <Box>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                    Country
                  </Typography>
                  <CountrySelect
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    style={{ width: "100%" }}
                  />
                </Box>

                {/* Terms and Conditions */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accept}
                      onChange={(e) => setAccept(e.target.checked)}
                      sx={{
                        color: theme.palette.primary.main,
                        '&.Mui-checked': {
                          color: theme.palette.primary.main,
                        },
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      I accept the{' '}
                      <Button
                        variant="text"
                        size="small"
                        onClick={() => navigate("/terms")}
                        sx={{ 
                          p: 0, 
                          minWidth: 'auto',
                          textTransform: 'none',
                          color: theme.palette.primary.main,
                          textDecoration: 'underline',
                          '&:hover': {
                            textDecoration: 'underline',
                          }
                        }}
                      >
                        terms and conditions
                      </Button>
                    </Typography>
                  }
                />

                {/* Payment Button */}
                <LoadingButton
                  onClick={handleClick}
                  loading={loading}
                  variant="contained"
                  disabled={!accept || paymentProcessed}
                  size="large"
                  fullWidth
                  sx={{
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    borderRadius: 2,
                    py: 1,
                    fontWeight: 600,
                    fontSize: '1rem',
                    textTransform: 'none',
                    boxShadow: `0 4px 16px ${alpha(theme.palette.primary.main, 0.3)}`,
                    '&:hover': {
                      background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                      boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
                    },
                    '&:disabled': {
                      background: theme.palette.grey[300],
                      color: theme.palette.grey[500],
                      boxShadow: 'none',
                    }
                  }}
                >
                  <SecurityIcon sx={{ mr: 1 }} />
                  Make Payment
                </LoadingButton>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CourseBilling;
